import React from "react";
import loadable from "@loadable/component";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";
import { tw } from "@careinfo/tailwind";
import ServiceTypeIcon from "../../Icons/ServiceTypeIcon";
const ShipviaListComponent = loadable(
  () => import("../../components/Shipvia/ShipviaList")
);
const ShipviaList = () => {
  const { mutateAsync: patchStatus, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["ship-via"],
    navigateURL: "",
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_default: value,
    };
    const url = `${APIS.SHIP_VIA}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <ServiceTypeIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Ship Via</span>
      </div>
      <ShipviaListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default ShipviaList;
